import React, { useEffect, useState } from 'react'
import { IDataDisplayer, IDataDisplayerColumnField, IDataDisplayerItem, IDataDisplayerItemField } from './DataDisplayer'
import { Checkbox } from '@mui/material'
import { useReturnSingleDispplayer } from './dataDisplyerSlice'

interface IProps {
    selectAllItems: () => void,
    displayer: IDataDisplayer,
    disableSelect?: boolean,
    customColumnItems?: IDataDisplayerColumnField[]
}

export default function HeaderDataDisplayer(props: IProps) {

    const { selectAllItems, disableSelect, customColumnItems } = props
    const displayer = useReturnSingleDispplayer(props.displayer.name)

    const containerID: string = "header-of-data-displayer_" + displayer.name
    const [minContainerWidth, setMinContainerWidth] = useState<number>()

    const columnItems = customColumnItems ? customColumnItems : displayer.columnItems

    const selected = displayer.selectedItems

    const baseContainerClassName: string = "data-displayer-header-container"
    const [containerClassName, setContainerClassName] = useState<string>(baseContainerClassName)

    useEffect(() => {
        if (selected.length > 0){
            setContainerClassName(baseContainerClassName + " selected-items")
        }else{
            setContainerClassName(baseContainerClassName)
        }
    }, [selected])

    const containerElem = document.getElementById(containerID)

    useEffect(() => {
        if (containerElem){
            setMinContainerWidth(containerElem.scrollWidth)
        }
    }, [containerElem])


    return(
        <div className={containerClassName} id={containerID} style={{ minWidth: minContainerWidth }}>
            <div className="content-of-data-displayer-header-container">

                {!disableSelect && (
                    <div className="single-data-displayer-header-item checkbox">
                        <div className="content-of-single-data-displayer-header-item">
                            <Checkbox disabled={displayer.items.length > 0 ? false : true} onClick={() => selectAllItems()} checked={selected.length > 0 ? true : false} />
                        </div>
                    </div>
                )}

                {selected.length > 0 && (
                    <div className="single-data-displayer-header-item" style={{ minWidth: "100%", maxWidth: "100%" }}>
                        <div className="content-of-single-data-displayer-header-item">
                            <h3>{`Selected (${selected.length})`}</h3>
                        </div>
                    </div>
                )}

                {columnItems.length > 0 && selected.length == 0 && columnItems.map((field: IDataDisplayerColumnField, index: number) => {

                    let minWidth = field.minWidth
                    let maxWidth = field.maxWidth

                    let label = field.label

                    if (field.type == "thumbnail"){
                        minWidth = 120
                        maxWidth = 120
                        // label = ""
                    }

                    if (!minWidth){
                        minWidth = 200
                    }

                    if (!maxWidth){
                        maxWidth = 200
                    }

                    if (displayer.hideColumnItems.includes(field.id)){
                        return <></>
                    }

                    return(
                        <div className="single-data-displayer-header-item" style={{ minWidth: minWidth, maxWidth: maxWidth }} key={index}>
                            <div className="content-of-single-data-displayer-header-item">
                                <h3>{label}</h3>
                            </div>
                        </div>
                    )
                })}

                <div className="single-data-displayer-header-item action-buttons">
                    <div className="content-of-single-data-displayer-header-item">
                        <h3></h3>
                    </div>
                </div>

            </div>
        </div>
    )
}